import numeral from 'numeral'
export default numeral
